
import clipboard from './module/clipboard'
import debounce from './module/debounce'
const directives = {
  clipboard,
  debounce
}

export default directives
